<template>
  <v-container class="pt-0" style="height: 100%">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="other"
          :redirect_name="redirect_name"
          :hide_back="inBottomNavbar"
        />
      </v-col>
    </v-row>

    <div
      v-if="src"
      class="mt-1"
      :style="{
        position: 'relative',
        width: 'calc(100% + 16px)',
        marginLeft: '-8px',
        height: showBottomNavbar ? 'calc(100% - 120px)' : 'calc(100% - 136px)',
        overflow: 'hidden',
      }"
    >
      <iframe
        ref="myIFrame"
        :src="src"
        :style="{
          width: '100%',
          height: '100%',
          border: '0px',
        }"
      ></iframe>
    </div>
    <div v-else>
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { mapState } from "vuex";
import { adjustHslBrightness } from "@/config/general-function";
import FloatPanel from "@/components/floatPanel.vue";
import { getFontColorBasedOnBg } from "../../../config/general-function.js";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    FloatPanel,
  },
  data: () => ({
    dialogFloatPanel: false,
    src: "https://wikipedia.org/",
    redirect_name: "main",
  }),
  async created() {
    this.isAppLoading(true);
    // ========== ========== ========== ==========
    if (this.src) {
      this.$nextTick(() => {
        this.setupIframeListener();
      });
    } else {
      this.isAppLoading(false);
    }
  },
  mounted() {
    // เพิ่ม listener เมื่อ component ถูก mount
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    // ลบ listener เมื่อ component ถูก unmount เพื่อป้องกัน memory leaks
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    setBackgoundBox() {
      const _color = this.site.color || "#00000";
      const darken = adjustHslBrightness(_color, -20);
      let _style = `linear-gradient(120deg, ${_color}, ${darken})`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `url("${this.customHeader.image}") center / cover no-repeat`;
      }
      return _style;
    },
    checkTitleShadow() {
      let shadow = "rgb(224 224 224) 2px 1px 1px";
      const color = getFontColorBasedOnBg(this.customHeader.titleColor, "bw");
      if (color == "#000000") {
        shadow = "rgb(66, 68, 90) 2px 1px 1px";
      }
      return shadow;
    },
    setBorderRadiusBox() {
      let _style = `0px 0px 25px 25px`;
      if (this.customHeader.isUseCustomHeader && this.customHeader.image) {
        _style = `0px !important`;
      }
      return _style;
    },
    // ========== ========== ========== ==========
    async sleep(msec) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, msec || 500);
      });
    },
    setupIframeListener() {
      const iframe = this.$refs.myIFrame;
      if (!iframe) {
        console.error("IFrame ref not found.");
        this.isAppLoading(false);
        return;
      }

      const handleIframeLoad = () => {
        this.isAppLoading(false);
      };
      iframe.addEventListener("load", handleIframeLoad);
      setTimeout(() => {
        this.isAppLoading(false);
      }, 5000);
    },
    handleMessage(event) {
      this.isAppLoading(false);
      // ตรวจสอบ origin ของผู้ส่งเพื่อความปลอดภัย
      // ใน production ควรเปลี่ยน "https://example.com" เป็น domain ที่เชื่อถือได้
      // if (event.origin !== "https://example.com") {
      //   return;
      // }

      // เก็บข้อมูลที่ได้รับจาก event.data
      const receivedMessage = event.data;
      console.log("ข้อความที่ได้รับ:", receivedMessage);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    inBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      const curRouteName = this.$router.currentRoute.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && listRouteName.includes(curRouteName)) {
        check = true;
      }
      return check;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}
</style>
